/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import Vue from 'vue'
import VueRouter from 'vue-router'

import loginRoutes from '@/modules/Authentication/router';
// import LocationCodeView from '@/modules/Location/index.vue'
// import ClockInOut from '@/modules/TimeClock/index.vue';
// import ClockInMsgView from '@/modules/TimeClock/components/submit.vue';
import Home from '@/modules/Home/Home.vue';
// import Profile from '@/modules/Employee/components/Profile.vue';
// import Login from '@/modules/Authentication/Login.vue';
// import SignUp from '@/modules/Authentication/SignUp.vue';
// import Logout from '@/modules/Authentication/Logout.vue';

const Main = () => import('@/modules/Layout/index.vue');

const PageNotFound = () => import('../views/PageNotFound.vue');

import BackOfficeRoutes from '@/modules/BackOffice/router';
import SignUpRoutes from '@/modules/SignUp/router';
import SettingsRoutes from '@/modules/Settings/router';
import ReportRoutes from '@/modules/Reports/EmployeeReport/router';
import { isNativeMobileApp } from '@/utils/mobileApp';

// Routes inside the main container. These routes will include the layout and the sidebar
let adminRoutes = [];
let backofficeRoutes = [];

backofficeRoutes = backofficeRoutes.concat(BackOfficeRoutes);


adminRoutes = adminRoutes.concat(ReportRoutes);
adminRoutes = adminRoutes.concat(SettingsRoutes);
adminRoutes = adminRoutes.concat([
{
  path: 'home',
  name: 'home',
  component: Home,
},
// {
//   name: 'employee-profile',
//   path: '/profile',
//   component: Profile,
// },

])

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

let routes = [{
    path: '/',
    name: 'main',
    children: adminRoutes,
    component: Main,
    redirect: {
      name: 'home'
    },
    beforeEnter: ((to, from, next) => {
      if (
				!(localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)) ||
				(localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null)
			) {
        next({
          path: '/login',
          params: {
            nextUrl: to.fullPath
          },
        });

      } else {
        // console.log('there in main', to)
        next()
      }
    })

  },
 
  {
    path: '*',
    name: 'pagenotfound',
    component: PageNotFound,
  },

]

routes = routes.concat(backofficeRoutes);
routes = routes.concat(loginRoutes);
routes = routes.concat(SignUpRoutes);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (isNativeMobileApp() && to.path.startsWith('/backoffice')) {
    next({ name: 'home' });
    return;
  }
  next();
});


// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null) {
//       console.log('i got here', to , from)
//       if (from && from.name !== 'signUp' || from.name !== 'backOfficeLogin') {
//         next({path: 'login'})
//       } 

//     } else {
//       next()
//     }
//   } else {
//     next() // make sure to always call next()!
//   }
// })



export default router
